import { useTheme } from '@simplywallst/ui-core';
import WarningSolid from '@simplywallst/ui-core/icons/WarningSolid';
import RewardSolid from '@simplywallst/ui-core/icons/RewardSolid';

type Severity = 'minor' | 'major' | 'none' | null;

interface Props {
  severity: Severity;
}

export const RiskReward = ({ severity }: Props) => {
  const theme = useTheme();
  return severity === 'minor' || severity === 'major' ? (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="6" fill="#FFF" />
      <WarningSolid
        fill={severity === 'major' ? theme.color.bad : theme.color.warning}
      />
    </svg>
  ) : (
    <RewardSolid fill={theme.color.good} />
  );
};
